import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule, Routes } from '@angular/router';
import { LottieModule } from 'ngx-lottie';

import { AcceptTokenComponent } from '@app/modules/accept-token/accept-token.component';
import { DashboardViewType } from '@shared/enums/dashboard-view-type';
import { RouteData } from '@shared/enums/route-data';
import { AnimationModule } from '@ui-components/components/animation/animation.module';

const routes: Routes = [
  {
    path: '',
    component: AcceptTokenComponent,
    data: { [RouteData.DASHBOARD_VIEW_TYPE]: DashboardViewType.NONE },
  },
];

@NgModule({
  declarations: [AcceptTokenComponent],
  imports: [CommonModule, MatProgressSpinnerModule, LottieModule, AnimationModule, RouterModule.forChild(routes)],
  exports: [AcceptTokenComponent],
})
export class AcceptTokenModule {}
